// Console Manager - Intercepts and filters console logs
// Only allows essential game information logs

/**
 * Disable all console output except for essential game information
 * Called from main.js at startup
 */
export function setupConsoleFilters() {
  // Save original console methods
  const originalConsole = {
    log: console.log,
    warn: console.warn,
    error: console.error,
    info: console.info,
    debug: console.debug
  };
  
  // Define patterns for essential logs to keep
  const essentialPatterns = [
    // Game banner and essential game info
    /^🚌 Fill The Tank!$/,
    /^This game is 100% made by AI\.$/,
    /^Follow me on X https:\/\/x\.com\/junwatu$/,
    /^\s*$/,
    /^\[Game\]/,
    /^Game animation loop started$/,
    /^Audio initialized successfully$/,
    /^Collision: Impact force =/,
    /^Created \d+ coins$/,
    
    // Keep critical errors
    /^Failed to initialize game:/,
    /^Physics not initialized after delay$/,
    /^Cannot add coins - physics not initialized!/,
    /^Error creating coin:/
  ];
  
  // Replace console methods with filtered versions
  console.log = function(...args) {
    const message = String(args[0] || '');
    
    // Check if this is an essential message to keep
    const isEssential = essentialPatterns.some(pattern => pattern.test(message));
    
    if (isEssential) {
      originalConsole.log.apply(console, args);
    }
    // Otherwise suppress the log
  };
  
  // Also filter warnings and errors but be more permissive with errors
  console.warn = function(...args) {
    const message = String(args[0] || '');
    const isEssential = essentialPatterns.some(pattern => pattern.test(message));
    
    if (isEssential) {
      originalConsole.warn.apply(console, args);
    }
  };
  
  console.error = function(...args) {
    const message = String(args[0] || '');
    
    // Let most errors through as they're usually important
    originalConsole.error.apply(console, args);
  };
  
  console.info = function(...args) {
    const message = String(args[0] || '');
    const isEssential = essentialPatterns.some(pattern => pattern.test(message));
    
    if (isEssential) {
      originalConsole.info.apply(console, args);
    }
  };
  
  console.debug = function(...args) {
    // Suppress all debug logs
  };
}

/**
 * Restore original console behavior
 * (For debugging purposes if needed)
 */
export function restoreConsole() {
  // This function would restore original console functionality
  // Implementation omitted as it's not needed for the current requirements
} 